import { Box } from '@mui/material'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { Resizable } from 'react-resizable'
import 'react-resizable/css/styles.css'
import { ResizeCallbackData } from 'react-resizable'

export function ResizableImage({
  src,
  initialWidth = 150,
}: {
  src: string
  initialWidth?: number
}) {
  const [width, setWidth] = useState(initialWidth)
  const [height, setHeight] = useState(initialWidth)
  const [dimension, setDimension] = useState(1)

  useEffect(() => {
    setWidth(initialWidth)
    setHeight(initialWidth)
    setDimension(1)
  }, [src, initialWidth])

  useEffect(() => {
    setHeight(width * dimension)
  }, [dimension, width])

  const onResize = (_: unknown, { size: { width } }: ResizeCallbackData) => {
    setWidth(width)
  }

  const onImgLoad = ({ target: img }: ChangeEvent<HTMLImageElement>) => {
    setDimension(img.offsetHeight / img.offsetWidth)
  }

  return (
    <Resizable
      className="box"
      axis="both"
      width={width}
      height={height}
      onResize={onResize}
    >
      <Box height={height} width={width} overflow="hidden">
        <img src={src} onLoad={onImgLoad} alt="resizable" width={width - 10} />
      </Box>
    </Resizable>
  )
}
